import { render, staticRenderFns } from "./danciPDec.vue?vue&type=template&id=ad97bbce&scoped=true"
import script from "./danciPDec.vue?vue&type=script&lang=js"
export * from "./danciPDec.vue?vue&type=script&lang=js"
import style0 from "./danciPDec.vue?vue&type=style&index=0&id=ad97bbce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../youyidian_pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad97bbce",
  null
  
)

export default component.exports